
import { FastingContextType } from './types';
import { useFastingState } from './useFastingState';

export const useFastingContextValue = (): FastingContextType => {
  const state = useFastingState();

  return {
    isActive: state.isActive,
    isPaused: state.isPaused,
    timeElapsed: state.timeElapsed,
    selectedProtocol: state.selectedProtocol,
    waterIntake: state.waterIntake,
    endTime: state.endTime,
    totalPauseDuration: state.totalPauseDuration,
    startFast: state.actions.startFast,
    pauseFast: state.actions.pauseFast,
    resumeFast: state.actions.resumeFast,
    stopFast: state.actions.stopFast,
    selectProtocol: state.actions.selectProtocol,
    increaseWaterIntake: state.actions.increaseWaterIntake,
    decreaseWaterIntake: state.actions.decreaseWaterIntake,
    estimatedCaloriesBurned: state.estimatedCaloriesBurned
  };
};
